export interface HeaderTabsProps {
  activeKey: string
  items: {
    label: string
    key: string
  }[]
  listClassName?: string
  onChange?: (key: string) => void
}

const defaultListClassName = cls`
  text-f-text-quaternary hover:text-f-text cursor-pointer rounded-t-2xl px-6 py-3 text-xl font-semibold
`

const activeListClassName = cls`
  !text-f-text bg-f-bg-elevated
`

const ellipseClassName = cls`
  bg-f-bg-elevated after:bg-f-other-1
  relative
  size-6 after:absolute after:bottom-0 after:left-0 after:size-6 after:content-['']
`

export default function HeaderTabs(props: HeaderTabsProps) {
  const { activeKey, items, listClassName, onChange } = props

  const handleClick = (key: string) => {
    onChange?.(key)
  }

  if (items.length === 0) return null

  return (
    <div className='flex'>
      {items.map((item, index) => {
        const isActiveTab = activeKey === item.key
        return (
          <div key={item.key} className='flex items-end'>
            {index > 0 && isActiveTab && (
              <div
                className={cls`
                  ${ellipseClassName} after:rounded-br-full
                `}
              ></div>
            )}
            <div
              className={cls`
                ${defaultListClassName}
                ${isActiveTab ? activeListClassName : ''}
                ${listClassName}
              `}
              onClick={() => handleClick(item.key)}
            >
              {item.label}
            </div>
            {isActiveTab && (
              <div
                className={cls`
                  ${ellipseClassName} after:rounded-bl-full
                `}
              ></div>
            )}
          </div>
        )
      })}
    </div>
  )
}
